import {QueryClient, QueryObserverOptions} from '@tanstack/react-query';
import HttpException from './exceptions/HttpException';

const MAX_RETRY_ATTEMPTS = 3;

export const defaultQueryClientSettings: QueryObserverOptions = {
    useErrorBoundary: true,
    refetchOnWindowFocus: false,
    networkMode: 'always',

    retry: (failureCount, error) => {
        return failureCount <= MAX_RETRY_ATTEMPTS && error instanceof HttpException && error.isShouldBeRetried();
    },
    retryDelay: attempt => Math.min(attempt > 1 ? 2 ** attempt : 1, 30) * 1000,
};

const queryClient = new QueryClient({
    logger: {
        log: message => {// eslint-disable-line
        },
        warn: message => {// eslint-disable-line
        },
        error: error => {// eslint-disable-line
        },
    },

    defaultOptions: {
        queries: defaultQueryClientSettings,
    },
});

export default queryClient;
